import {
  createContext, useState, useMemo, memo,
} from 'react';

const Context = createContext(null);

function RouteContext({ children }) {
  const [ basename, setBasename ] = useState();

  const contextValue = useMemo(() => ({
    basename,
    setBasename,
  }), [ basename, setBasename ]);

  return (
    <Context.Provider value={contextValue}>
      {children}
    </Context.Provider>
  );
}

const RouteContextProvider = memo(RouteContext);

export { RouteContextProvider, Context as RouteContext };
